import GiftIcon from './GiftIcon';

export default GiftIcon;
